<template>
  <div class="dashboard-container">
    <!-- 1. 左侧侧边栏 -->
    <div class="sidebar-wrapper">
      <HotelListSidebar 
        :raw-hotel-list="rawHotelList"
        :current-hotel-id="selectedHotelId"
        @hotels-filtered="handleHotelsFiltered"
        @hotel-click="handleSidebarClick"
        @exhibition-change="handleExhibitionChange" 
        @date-range-change="handleDateRangeChange" 
        @city-change="handleCityChange" 
      />
    </div>

    <!-- 2. 地图组件 -->
    <div class="map-wrapper">
      <HotelMap 
        ref="hotelMapRef"
        :hotel-list="currentHotelList"
        :halls="allHalls"                  
        :selected-exhibition="selectedExhibition"
        @hotel-click="handleMapMarkerClick"
        
      />
    </div>

    <!-- 3. 详情抽屉 -->
    <HotelDetailDrawer 
      :visible.sync="drawerVisible" 
      :hotel="currentHotel" 
      :filter-date-range="currentDateRange" 
    />
  </div>
</template>

<script>
// 引入数据
import hallsData from '../../data/halls.json'; 

// 引入组件
import HotelListSidebar from '../HotelListSidebar.vue';
import HotelDetailDrawer from '../HotelDetailDrawer.vue';
import HotelMap from './HotelMap.vue';

export default {
  name: 'HotelMapDashboard',
  components: {
    HotelListSidebar,
    HotelDetailDrawer,
    HotelMap
  },
  data() {
    return {
      rawHotelList: [],
      
      currentHotelList: [],
      selectedHotelId: null,
      currentHotel: null,
      drawerVisible: false,
      allHalls: hallsData["上海"], // 获取上海展馆列表
      selectedExhibition: null,    // 记录当前选中的展会
       currentDateRange: [], // ★ 新增：存储当前筛选的日期范围
    };
  },
  created() {
    // 模拟数据加载
    //this.rawHotelList = hotelApiData.Datas;
  },
  methods: {

    // ★★★ 新增：处理城市变更 ★★★
    handleCityChange(city) {
      // 根据城市名更新展馆列表，如果没有找到对应城市则为空数组
      this.allHalls = hallsData[city] || [];
      
      // 清空当前选中的展会（因为城市变了，之前的展会肯定不属于这个城市）
      this.selectedExhibition = null;
      
      // 清空当前的酒店列表（可选，根据业务需求，切换城市后理论上之前的酒店也不对了）
      // this.currentHotelList = [];
      // this.$refs.hotelMapRef.clearMap(); // 如果你有封装清理方法
    },

    // ★ 新增：处理日期变更
    handleDateRangeChange(range) {
      this.currentDateRange = range;
    },
    // 列表筛选更新
    handleHotelsFiltered(filteredList) {
      this.currentHotelList = filteredList;
    },

    // 侧边栏点击 -> 联动地图定位 + 打开详情
    handleSidebarClick(hotel) {
      
      const lat = parseFloat(hotel.lat || hotel.Latitude);
      const lng = parseFloat(hotel.lng || hotel.Longitude);
      this.$refs.hotelMapRef.focusLocation(lat, lng);

      setTimeout(() => {
         this.openDetail(hotel);
      }, 900);
      
    },

    // 地图Marker点击 -> 打开详情
    handleMapMarkerClick(hotel) {
      
      const lat = parseFloat(hotel.lat || hotel.Latitude);
      const lng = parseFloat(hotel.lng || hotel.Longitude);
      this.$refs.hotelMapRef.focusLocation(lat, lng);

      this.openDetail(hotel);
    },

    openDetail(hotel) {
      this.selectedHotelId = hotel.HotelId;
      this.currentHotel = hotel;
      this.drawerVisible = true;
    },

    // 增加处理展会变更的方法
    handleExhibitionChange(exh) {
      console.log('Dashboard: 收到展会变更信号 ->', exh); // 调试日志
      this.selectedExhibition = exh;
    }
    
  }
};


</script>

<style scoped lang="scss">
@use "@/assets/styles/dashboard/layout.scss";
</style>